/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect } from 'react';
import { StyleSheet, Text, View, Pressable } from 'react-native';
import Image from '@web/components/common/Image';
// import { useSafeAreaInsets } from 'react-native-safe-area-context';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { StackActions } from '@react-navigation/native';
import Toast from 'react-native-toast-message';

import WithLocalSvg from '@web-components/common/WithLocalSvg';
import * as authActions from '~store/user/actions/auth';
import OtpVerificationScreen from '@web/screens/OtpVerificationScreen';
import Colors from '~global/Colors';
import { data as Fonts } from '~global/Fonts';
import ErrorCodes from '~global/ErrorCodes';
import { isWeb } from '~global/screens';
const Cookies = require('js-cookie');
const OtpForm = (props) => {
  const { $size } = global;

  const dispatch = useDispatch();
  const autoRedirect = useSelector((state) => state.auth.autoRedirect);
  // const insets = useSafeAreaInsets();
  const { navigation, route, fullscreen = false } = props;
  const params = route.params;
  const paramsPhoneNo = Cookies.get('phone_no');
  // const phoneNumber =
  // paramsPhoneNo &&
  //   `${paramsPhoneNo.slice(0, 3)}-******-${paramsPhoneNo.slice(-3)}`;
  const [screenName, setScreenName] = useState(
    params.screenName ? params.screenName : 'choose_verification_method',
  );
  const [verificationMethod, setVerificationMethod] = useState('');
  const [payload, setPayload] = useState({
    password: '',
    confirmationPassword: '',
  });

  const getPhoneNumber = () => {
    const phone = Cookies.get('phone_no');
    return phone && `${phone.slice(0, 3)}-******-${phone.slice(-3)}`;
  };

  // ............hooks
  useEffect(() => {
    let isMounted = true;

    const toggleSmsOtp = async () => {
      await dispatch(authActions.getFeatureToggleOtp('sms'));
    };
    const toggleWhatsappOtp = async () => {
      await dispatch(authActions.getFeatureToggleOtp('whatsapp'));
    }; /*
    const toggleEmailOtp = async () => {
      await dispatch(authActions.getFeatureToggleOtp('email'));
    };*/

    if (isMounted) {
      toggleSmsOtp();
      toggleWhatsappOtp();
      // toggleEmailOtp();
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  useEffect(() => {
    if (params?.verify === 'email' && isWeb) {
      navigation.setParams({ section: 'email' });
      otpHandler(params?.verify);
    }
    if (!global.isWeb && params?.verify) {
      openVerificationScreen(params.verify);
    }
    if (global.isMobileWeb) {
      navigation.setOptions({
        headerLeft: (props2) => (
          <Pressable
            onPress={() => {
              if (params?.previous) {
                navigation.reset({
                  index: 0,
                  routes: [{ name: params.previous }],
                });
                return;
              }
              if (screenName === 'verification_screens') {
                setScreenName('choose_verification_method');
                return;
              }
              try {
                navigation.pop();
              } catch (e) {
                navigation.goBack();
              }
            }}>
            <Image
              style={{ height: 20, width: 20, marginLeft: 16 }}
              source={require('~assets/img/common/arrow-back.png')}
            />
          </Pressable>
        ),
      });
    }
  }, [params, screenName]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (verificationMethod != '' && !props?.route?.params?.section) {
        setVerificationMethod('');
      } else if (params?.section) {
        setVerificationMethod(params?.section);
      }
    }
    if (params.screenName) {
      setScreenName(params.screenName);
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  // ............methods
  // eslint-disable-next-line no-unused-vars
  const setPayloadHandler = (data) => {
    setPayload({
      ...payload,
      ...data,
    });

    verifiedForm();
  };

  const verifiedForm = () => {
    if (payload.password && payload.confirmationPassword) {
      // eslint-disable-next-line no-undef
      setDisabledSubmit(false);
    } else {
      // eslint-disable-next-line no-undef
      setDisabledSubmit(true);
    }
  };

  const otpHandler = async (mode) => {
    let res;
    const entity = mode == 'email' ? 'email' : 'phone_no';
    if (params?.quick_registration) {
      res = await dispatch(
        authActions.getOtpLoginRequest({
          entity,
          mode: mode,
          entity_value: params[entity],
          user_id: params.user_id,
          ...(entity === 'phone_no' && { phone_code: params.phone_code }),
        }),
      );
    } else {
      res = await dispatch(
        authActions.getOtp({
          entity,
          mode: mode,
          [entity]: params[entity],
        }),
      );
    }

    if (res?.errorCode) {
      Toast.show({ text1: ErrorCodes[res.errorCode], type: 'error' });
    } else {
      setVerificationMethod(mode);
      setScreenName('verification_screens');
      const message = {
        sms: 'Code sent. Please check SMS.',
        whatsapp: 'Code sent. Please check your WhatsApp.',
        email: 'Code sent. Please check your email.',
      };
      Toast.show({ text1: message[mode] });
    }
  };

  const forgotPassword = async (mode) => {
    const entity = mode == 'email' ? 'email' : 'phone_no';
    if (entity === 'email') {
      props.navigation.navigate('ForgotPasswordScreen', { tab: 'email' });
      return;
    }

    const res = await dispatch(
      authActions.userForgetPassword({
        mode: mode,
        [entity]: params[entity] ? params[entity] : paramsPhoneNo,
      }),
    );
    if (res?.errorCode) {
      Toast.show({ text1: ErrorCodes[res.errorCode], type: 'error' });
    } else {
      setVerificationMethod(mode);
      setScreenName('verification_screens');
      const message = {
        sms: 'Code sent. Please check SMS.',
        whatsapp: 'Code sent. Please check your WhatsApp.',
        email: 'Code sent. Please check your email.',
      };
      Toast.show({ text1: message[mode] });
    }
  };

  const openVerificationScreen = (mode) => {
    fullscreen && navigation.setParams({ section: mode });

    if (params.forgot) {
      forgotPassword(mode);
    } else {
      otpHandler(mode);
    }
  };

  const handleVerifyLater = () => {
    const isAutoRedirect = $size(autoRedirect);
    dispatch({ type: 'MODAL/HIDE', modalName: 'verifyAccount' });
    if (isAutoRedirect) {
      props.navigation.navigate(autoRedirect?.screen, autoRedirect?.params);
    } else {
      navigation.dispatch({
        ...StackActions.popToTop(),
      });
      navigation.navigate('Shop');
    }
  };

  const handleChangePhoneNumber = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'verifyAccount' });
    dispatch({
      type: 'MODAL/SHOW',
      modalName: 'changePhoneNumber',
      data: { fullscreen, params, mode: verificationMethod },
    });
  };

  return (
    <View style={[styles.wrapper, { paddingBottom: 16 }]}>
      {screenName === 'choose_verification_method' && (
        <>
          {isWeb && <Text style={styles.title}>Verify Your Account</Text>}
          <View style={styles.wrapperChild}>
            {params.forgot ? (
              <Text
                style={[
                  styles.textInfo,
                  { ...(fullscreen && { fontSize: 16 }), marginBottom: 24 },
                ]}>
                Sebelum melakukan pengubahan password, untuk memastikan
                kelancaran berbelanja dan keamanan akun kamu, kami akan
                mengirimkan kode verifikasi.
              </Text>
            ) : (
              <Text
                style={[
                  styles.textInfo,
                  { ...(fullscreen && { fontSize: 16 }), marginBottom: 24 },
                ]}>
                To ensure smooth shopping experience and the security of your
                account, we will send you a verification code.
              </Text>
            )}

            <Text style={styles.textHeading}>Choose verification method :</Text>

            <Pressable
              style={styles.card}
              onPress={() => openVerificationScreen('whatsapp')}>
              <WithLocalSvg
                key="whatsappSmall"
                width={32}
                height={24}
                style={styles.cardIcon}
                asset={require('~assets/img/common/whatsapp-logo.svg')}
              />
              <Text style={styles.cardText}>
                Via WhatsApp to {getPhoneNumber()}
              </Text>
            </Pressable>

            <Pressable
              style={styles.card}
              onPress={() => openVerificationScreen('sms')}>
              <WithLocalSvg
                key="phoneTextingSmall"
                width={32}
                height={32}
                style={styles.cardIcon}
                asset={require('~assets/img/smartphone-v2.svg')}
              />
              <Text style={styles.cardText}>Via SMS to {getPhoneNumber()}</Text>
            </Pressable>
          </View>

          {params.forgot && (
            <>
              <Text style={[styles.textInfo, styles.retryText]}>
                Tidak menerima kode melalui WhatsApp dan SMS?
              </Text>
              <Text
                style={[styles.textInfo, styles.emailText]}
                onPress={() => openVerificationScreen('email')}>
                Verifikasi lewat email
              </Text>
              {!params.forgot && (
                <>
                  {fullscreen ? (
                    <View style={{ height: 70 }} />
                  ) : (
                    isWeb && (
                      <Text
                        style={[
                          styles.verifyLaterText,
                          { marginVertical: 12 },
                        ]}>
                        or
                      </Text>
                    )
                  )}
                </>
              )}
            </>
          )}
          {!params?.quick_registration && (
            <Pressable style={styles.verifyLater} onPress={handleVerifyLater}>
              <Text style={[styles.textInfo, styles.verifyLaterText]}>
                Verify later
              </Text>
            </Pressable>
          )}
        </>
      )}

      {screenName === 'verification_screens' && (
        <OtpVerificationScreen
          state={params.state}
          phone_no={paramsPhoneNo}
          phone_code={params.phone_code}
          email={params.email}
          forgot={params.forgot}
          destinationRoute={params?.destinationRoute}
          previous={params?.previous}
          quick_registration={params?.quick_registration}
          handleResend={() => otpHandler(verificationMethod)}
          handleScreenChange={() => setScreenName('choose_verification_method')}
          onChangePhoneNumber={handleChangePhoneNumber}
          section={params.section}
          user_id={params.user_id}
          hash={params.hash}
          {...{ navigation, fullscreen, verificationMethod }}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: Colors.white,
    position: 'relative',
    paddingHorizontal: 16,
    flex: 1,
  },
  wrapperChild: {
    paddingTop: 16,
  },
  card: {
    width: '100%',
    height: 48,
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: 4,
    backgroundColor: Colors.white,
    marginBottom: 16,
    flexDirection: 'row',
    paddingHorizontal: 14,
    shadowColor: Colors.black,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.12,
    shadowRadius: 4,
    elevation: 3,
    ...(isWeb && { cursor: 'pointer' }),
  },
  cardText: {
    color: Colors.purple7,
    fontSize: 13,
    lineHeight: 16,
    fontFamily: 'satoshi-medium',
  },
  cardIcon: {
    marginRight: 16,
  },
  emailText: {
    fontFamily: 'satoshi-bold',
    color: Colors.purple4,
    textAlign: 'center',
    textDecorationLine: 'underline',
    fontSize: isWeb ? 13 : 14,
  },
  retryText: {
    fontSize: isWeb ? 13 : 14,
    textAlign: 'center',
  },
  textInfo: {
    color: Colors.grey2,
    lineHeight: 22,
    fontFamily: 'satoshi-medium',
    fontSize: 14,
  },
  textHeading: {
    color: Colors.purple7,
    fontSize: 14,
    lineHeight: 24,
    fontFamily: 'satoshi-medium',
    marginBottom: 16,
  },
  title: {
    marginBottom: 12,
    fontSize: 20,
    color: Colors.purple7,
    ...Fonts.satoshiMedium,
  },
  verifyLater: {
    ...(isWeb && { cursor: 'pointer' }),
  },
  verifyLaterText: {
    fontSize: 14,
    color: Colors.purple7,
    textAlign: 'center',
  },
});

OtpForm.propTypes = {
  route: PropTypes.object,
  navigation: PropTypes.object,
  fullscreen: PropTypes.bool,
};

OtpForm.defaultProps = {
  route: { params: {} },
  navigation: {},
};

export default OtpForm;
